import { DataLoadObj, WizConstants } from '@wizeoo/akm-compute-lib';
import { Baseline, FreeData, Matrix, WorkCom } from '@wizeoo/akm-message-lib';
import { AkmBDD, BddBaseline, BddFEI, BddFreedata, BddMatrix, BddMatrixData, BddWorkcom } from '@wizeoo/akm-worker-lib';
import { FreedataDataload } from '../../vo/core/freedata.dataload';
import { WorkcomDataload } from '../../vo/workflow/workcom.dataload';
import { MatrixDataLoad } from '../../vo/matrix/matrix.dataload';
import { Model } from '../../model/model';


/**
 * web worker pour alimentation du cache local en arrière plan
 * va activer le worker allkey.worker.js
 */
export class AllkeyWebWorker {

  private static _webworker: Worker; // un worker au sens browser (un machin qui travaille en back, accède au cache du browser...)
  public static get webworker(): Worker {
    return AllkeyWebWorker._webworker;
  }
  public static set webworker(value: Worker) {
    AllkeyWebWorker._webworker = value;
  }

  /**
   * enregistrement local d'un FEI
   * @param key clé du fei
   * @param value valeur à stocker
   * @param storeKey clé de BDD (voir akmBDD)
   */
  public static storeFei(key: string, value: BddFEI) {
    AkmBDD.getInstance().doAdd(AkmBDD.BDD_FEI_KEY, key, value);
  }

  /** persistence d'un média */
  public static storeMedia(key: any, value: any, storeKey: string) {
    this.webworker.postMessage({ key, value, type: 'SET', storeKey });
    // this._worker.postMessage({ key, value, type: 'SET', storeKey });
  }

  /** persistence d'un FD */
  public static storeFreedata(dataload: FreedataDataload) {;
    // console.log('updateIndexDBData', dataload);
    if(dataload.toPersist?.size > 0) {
      const pairs: BddFreedata[] = [];
      [...dataload.toPersist.values()].forEach((fd: FreeData) => {
        pairs.push({id: fd.id, buKey: dataload.uniqueKey, code: fd.code, revisionNumber: dataload.revisionNumber, value : fd});
      });
      // AkmBDD.getInstance().doBulkFreedatas(pairs)
      this.webworker.postMessage({ type: 'ADDFREEDATAS', pairs });
    }


    if(dataload.toDie?.size > 0) {
      const pairs: any[] = [];
      [...dataload.toDie.keys()].forEach((key: number) => {
        pairs.push(key);
      });
      // AkmBDD.getInstance().doBulkDelete(AkmBDD.BDD_FREEDATA_KEY ,pairs);
      this.webworker.postMessage({ type: 'DELETEFREEDATAS', pairs, storeKey: AkmBDD.BDD_FREEDATA_KEY });
    }
  }  

  /** persistence des dataloads On ne passe pas par le worker (lock). Va chainer avec les deletes */
  public static updateDataload(dataload: DataLoadObj, callback: Function) {
    // console.log('updateDataload', dataload);
    if(dataload.toPersistBaseline?.size > 0) {
      const pairs: BddBaseline[] = [];
        
      [...dataload.toPersistBaseline.values()].forEach((bl: Baseline) => {
        pairs.push({id: bl.id, feiKey: dataload.uniqueKey, key: bl.key, level: bl.level, scen: bl.scen, value : bl});
      });
      
      // console.log('updateDataload', pairs);
      AkmBDD.getInstance().doBulkAddBaselines(pairs, dataload, callback, this.updateDataloadDoDelete);
      // this._worker.postMessage({ type: 'ADDBASELINES', pairs});
    } else { // pas de modifs / création
      this.updateDataloadDoDelete(dataload, callback);
    }
  }

  /** persistence des dataloads On ne passe pas par le worker (lock) */
  public static updateDataloadDoDelete(dataload: DataLoadObj, callback: Function) {
    // console.log('updateDataloadDoDelete', dataload);
    if(dataload.toDieBaseline?.size > 0) {
      const pairs: any[] = [];
      [...dataload.toDieBaseline.values()].forEach((bl: Baseline) => {
        // console.log('bdd delete', bl.id, bl.scen, bl.key);
        pairs.push(bl.id);
      });

      AkmBDD.getInstance().doBulkDelete(AkmBDD.BDD_BASELINE_KEY , pairs, dataload, callback);
      // this._worker.postMessage({  type: 'DELETEBASELINES', pairs, storeKey: AkmBDD.BDD_BASELINE_KEY });
    } else {
      if(!!callback) {
        callback(dataload);
      }
    }
    // console.log('updateIndexDBData  dalatload end');
  }

  /** persistence d'un Workcom */
  public static storeWorkcom(dataload: WorkcomDataload) {; 
    if(dataload.toPersist?.size > 0) {
      const pairs: BddWorkcom[] = [];
      [...dataload.toPersist.values()].forEach((wc: WorkCom) => {
        pairs.push({id: wc.id, key: wc.naturalUID, buKey: dataload.uniqueKey, value : wc});
      });
      this.webworker.postMessage({ type: 'ADDWORKCOMS', pairs });
    }


    if(dataload.toDie?.size > 0) {
      const pairs: any[] = [];
      [...dataload.toDie.keys()].forEach((key: number) => {
        pairs.push(key);
      });
      this.webworker.postMessage({ type: 'DELETEWORKCOMS', pairs, storeKey: AkmBDD.BDD_WORKCOM_KEY });
    }
  }   

  /** persistence d'une Matrix */
  public static storeMatrix(dataload: MatrixDataLoad) {; 
    if(dataload.toPersist?.size > 0) {
      const pairs: BddMatrix[] = [];
      [...dataload.toPersist.values()].forEach((mat: Matrix) => {
        pairs.push({id: mat.id, key: mat.code, buKey: dataload.uniqueKey, value : mat});
      });
      this.webworker.postMessage({ type: 'ADDMATRIX', pairs });
    }


    if(dataload.toDie?.size > 0) {
      
      const pairs: any[] = [];
      [...dataload.toDie.keys()].forEach((key: number) => {
        pairs.push(key);
      });


      // suppression de la partie "Matrice"
      this.webworker.postMessage({ type: 'DELETEMATRIX', pairs, storeKey: AkmBDD.BDD_MATRIX_KEY });
      // suppression de la partie "rows"
      this.webworker.postMessage({ type: 'DELETEMATRIXDATA', ids:pairs, storeKey: AkmBDD.BDD_MATRIX_DATA_KEY });
    }
  }   
 
  /** persistence d'une Matrix (ROWS) */
  public static storeMatrixDatas(mats: Matrix[]) {; 
    
    // suppression de l'existant
    const ids: any[] = [];
    mats.forEach((mat: Matrix) => {
      ids.push(mat.id);
    });
    // console.log('storeMatrixDatas', ids);
    // this.webworker.postMessage({ type: 'DELETEMATRIXDATA', ids, storeKey: AkmBDD.BDD_MATRIX_DATA_KEY });

    let pairs: BddMatrixData[] = [];
    mats.forEach((mat: Matrix) => {
      // suppression de la partie "rows"
      
      let rows: BddMatrixData[] = this.MatrixRowToBddMatrixData(mat);

      pairs = pairs.concat(rows);//  = [...pairs, ...];
      // let buKey: string = [mat.domain, mat.businessUnitCode].join(WizConstants.KEY_SEPARATOR);
      // pairs.push({id: mat.id, key: mat.code, buKey, value : mat});
      // console.log('ADDMATRIXDATA rows', rows.length);
    });
    // console.log('ADDMATRIXDATA', pairs.length);
    this.webworker.postMessage({ type: 'ADDMATRIXDATA', ids, pairs });
  } 

  // conversion d'une row de matrix en BddMatrixData
  public static MatrixRowToBddMatrixData(matrix: Matrix): BddMatrixData[] {
    
    let id: number = matrix.id;
    let key: string = matrix.code;
    let buKey: string = [matrix.domain, matrix.businessUnitCode].join(WizConstants.KEY_SEPARATOR);
    let rows: any[] = JSON.parse(matrix.rows as any) as any[];
        
    let result: BddMatrixData[] = [];
    // let item: BddMatrixData;
    rows.forEach(r => {
      result.push({matrixid:id, key, buKey, ...r});
    });

    return result;
  }


}
